import type * as pc from 'playcanvas'

/**
 * Where world geometry attaches.
 *
 * The office interior is authored in its own local coordinates (origin-centred,
 * 36 x 24 m) and every existing constant, placement and test depends on that.
 * Rather than rewrite all of it in district coordinates, the whole interior is
 * parented to one entity that the district positions and rotates — so the
 * office becomes "the inside of the anchor building" by setting a transform,
 * and its local space is untouched.
 *
 * Null means attach directly to the app root (the standalone-office case).
 */
let _root: pc.Entity | null = null

export function setWorldRoot(root: pc.Entity | null): void {
  _root = root
}

/** The parent for world geometry — the interior root if set, else app.root. */
export function worldRoot(app: pc.Application): pc.Entity {
  return _root ?? app.root
}
